/**
 * Reports View
 */
export default () => ({
  path : '/action-plans',
  title: 'Planes de Acción',

  onEnter: (nextState, transition) => {
    console.log(nextState)
    if (nextState.location.pathname === 'action-plans') {
      transition({ pathname: '/action-plans/stats' })
    }
  },

  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const ActionPlansLayout = require('./components/ActionPlansLayout').default
      const AlertStatusBar = require('../../components/AlertsStatusBar').default
      
      cb(null, { 
        content: ActionPlansLayout,
        statusBar: AlertStatusBar
      })
    }, 'action-plans')
  },

  getChildRoutes (location, callback) {
    callback(null, [
      {
        path : 'stats',   
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const ActionPlansStatsContainer = require('./containers/ActionPlansStatsContainer').default
            cb(null, ActionPlansStatsContainer)
          }, 'action-plans-stats')
        },
      },
      {
        path : '(:id)', 
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const ActionPlansDetailContainer = require('./containers/ActionPlansDetailContainer').default
            cb(null, ActionPlansDetailContainer)
          }, 'action-plans-detail')
        },
      },
    ])
  }
})



// WEBPACK FOOTER //
// ./src/routes/ActionPlans/index.js